let css = require('./component.css');
let { cut } = require('../../helpers/utils');

const SELECTOR_STATE = cut(css.state);

class Devtools {
    constructor (serviceLocator) {
        this._locator = serviceLocator;
        this.template = require('./template.hbs');
    }

    /**
     * Render method
     * @returns {Object}
     */
    render () {
        return { css };
    }

    bind () {
        this._history = this._locator.resolve('history');

        return {
            click: {
                [SELECTOR_STATE]: this.logStateTree
            }
        };
    }

    logStateTree (e) {
        e.preventDefault();
        e.stopPropagation();

        this._history.logTree();
    }
}

module.exports = {
    constructor: Devtools
};



// WEBPACK FOOTER //
// ./components/devtools/index.js